<!-- src/home/salesPreset/SummaryCards.vue -->
<template>
  <div class="summary-cards-container">
    <!-- 1. 项目卡片 -->
    <el-tooltip
      effect="light"
      placement="top"
      popper-class="custom-tooltip"
    >
      <div slot="content" v-html="getCardTooltip('project')"></div>
      <div class="summary-card project-card">
        <!-- 左侧：图标 + 标签 -->
        <div class="card-left">
          <div class="card-icon">
            <img src="@/assets/images/Vector_40_1213.png" class="card-image">
          </div>
          <div class="card-title">项目</div>
        </div>
        
        <!-- 右侧：数据展示（4行） -->
        <div class="card-right">
          <!-- 移动端标签 -->
          <div class="mobile-card-title">项目</div>
          <div class="data-item">
            <span class="data-value">{{ formatNumber(cardData.project.value1) || '1,000' }}</span>
          </div>
          <div class="data-item">
            <span class="data-label">已投标</span>
          </div>
          <div class="data-item">
            <span class="data-value">{{ formatNumber(cardData.project.value2) || '2,000' }}</span>
          </div>
          <div class="data-item">
            <span class="data-label">项目总数</span>
          </div>
        </div>
      </div>
    </el-tooltip>
    
    <!-- 2. 合同卡片 -->
    <el-tooltip
      effect="light"
      placement="top"
      popper-class="custom-tooltip"
    >
      <div slot="content" v-html="getCardTooltip('contract')"></div>
      <div class="summary-card contract-card">
        <!-- 左侧：图标 + 标签 -->
        <div class="card-left">
          <div class="card-icon">
            <img src="@/assets/images/Vector_50_9259.png" class="card-image">
          </div>
          <div class="card-title">合同</div>
        </div>
        
        <!-- 右侧：数据展示（4行） -->
        <div class="card-right">
          <!-- 移动端标签 -->
          <div class="mobile-card-title">合同</div>
          <div class="data-item">
            <span class="data-value">{{ formatToTenThousand(cardData.contract.value1) || '1,000万' }}</span>
          </div>
          <div class="data-item">
            <span class="data-label">未审核金额</span>
          </div>
          <div class="data-item">
            <span class="data-value">{{ formatToTenThousand(cardData.contract.value2) || '2,000万' }}</span>
          </div>
          <div class="data-item">
            <span class="data-label">累计金额</span>
          </div>
        </div>
      </div>
    </el-tooltip>

    <!-- 3. 执行卡片 -->
    <el-tooltip
      effect="light"
      placement="top"
      popper-class="custom-tooltip"
    >
      <div slot="content" v-html="getCardTooltip('execute')"></div>
      <div class="summary-card execute-card">
        <!-- 左侧：图标 + 标签 -->
        <div class="card-left">
          <div class="card-icon">
            <div class="composite-icon">
              <img src="@/assets/images/Vector_50_9113.png" alt="背景图标" class="card-image-bg">
              <img src="@/assets/images/Vector_50_9112.png" alt="前景图标" class="card-image-fg">
            </div>
          </div>
          <div class="card-title">执行</div>
        </div>
        
        <!-- 右侧：数据展示（4行） -->
        <div class="card-right">
          <!-- 移动端标签 -->
          <div class="mobile-card-title">执行</div>
          <div class="data-item">
            <span class="data-value">{{ formatNumber(cardData.execute.value1) || '12' }}</span>
          </div>
          <div class="data-item">
            <span class="data-label">异常执行合同</span>
          </div>
          <div class="data-item">
            <span class="data-value">{{ formatNumber(cardData.execute.value2) || '30' }}</span>
          </div>
          <div class="data-item">
            <span class="data-label">执行中合同</span>
          </div>
        </div>
      </div>
    </el-tooltip>

    <!-- 4. 发运卡片 -->
    <el-tooltip
      effect="light"
      placement="top"
      popper-class="custom-tooltip"
    >
      <div slot="content" v-html="getCardTooltip('shipment')"></div>
      <div class="summary-card shipment-card">
        <!-- 左侧：图标 + 标签 -->
        <div class="card-left">
          <div class="card-icon">
            <div class="composite-icon">
              <img src="@/assets/images/Vector_347_69064.png" alt="背景图标" class="card-image-bg">
              <img src="@/assets/images/Vector_347_69063.png" alt="前景图标" class="card-image-fg">
            </div>
          </div>
          <div class="card-title">发运</div>
        </div>
        
        <!-- 右侧：数据展示（4行） -->
        <div class="card-right">
          <!-- 移动端标签 -->
          <div class="mobile-card-title">发运</div>
          <div class="data-item">
            <span class="data-value">{{ formatNumber(cardData.shipment.value1) || '100' }}</span>
          </div>
          <div class="data-item">
            <span class="data-label">异常发运合同数</span>
          </div>
          <div class="data-item">
            <span class="data-value">{{ formatNumber(cardData.shipment.value2) || '800' }}</span>
          </div>
          <div class="data-item">
            <span class="data-label">待发运合同数</span>
          </div>
        </div>
      </div>
    </el-tooltip>
    
    <!-- 5. 售后卡片 -->
    <el-tooltip
      effect="light"
      placement="top"
      popper-class="custom-tooltip"
    >
      <div slot="content" v-html="getCardTooltip('afterSales')"></div>
      <div class="summary-card after-sales-card">
        <!-- 左侧：图标 + 标签 -->
        <div class="card-left">
          <div class="card-icon">
            <img src="@/assets/images/Vector_50_9557.png" class="card-image">
          </div>
          <div class="card-title">售后</div>
        </div>
        
        <!-- 右侧：数据展示（4行） -->
        <div class="card-right">
          <!-- 移动端标签 -->
          <div class="mobile-card-title">售后</div>
          <div class="data-item">
            <span class="data-value">{{ formatNumber(cardData.afterSales.value1) || '30' }}</span>
          </div>
          <div class="data-item">
            <span class="data-label">未完成售后数</span>
          </div>
          <div class="data-item">
            <span class="data-value">{{ formatNumber(cardData.afterSales.value2) || '200' }}</span>
          </div>
          <div class="data-item">
            <span class="data-label">总售后数</span>
          </div>
        </div>
      </div>
    </el-tooltip>

    <!-- 6. 应收卡片 -->
    <el-tooltip
      effect="light"
      placement="top"
      popper-class="custom-tooltip"
    >
      <div slot="content" v-html="getCardTooltip('receivable')"></div>
      <div class="summary-card receivable-card">
        <!-- 左侧：图标 + 标签 -->
        <div class="card-left">
          <div class="card-icon">
            <img src="@/assets/images/Vector_50_9697.png" class="card-image">
          </div>
          <div class="card-title">应收</div>
        </div>
        
        <!-- 右侧：数据展示（应收卡片只有2行，用空行补齐4行） -->
        <div class="card-right">
          <!-- 移动端标签 -->
          <div class="mobile-card-title">应收</div>
          <div class="data-item">
            <span class="data-value">{{ formatToTenThousand(cardData.receivable.value1) || '145.6万' }}</span>
          </div>
          <div class="data-item">
            <span class="data-label">应收金额（含预收）</span>
          </div>
          <!-- 应收卡片空出两行，保持布局一致 -->
          <div class="data-item empty-item"></div>
          <div class="data-item empty-item"></div>
        </div>
      </div>
    </el-tooltip>
  </div>
</template>
<script>
export default {
  name: 'SummaryCards',
  props: {
    // 从父组件传递下来的数据
    cardData: {
      type: Object,
      default: () => ({
        project: { value1: null, value2: null, tableData: { bidding: [] } },
        contract: { value1: null, value2: null, unReviewCount: null },
        execute: { value1: null, value2: null },
        shipment: { value1: null, value2: null },
        afterSales: { value1: null, value2: null },
        receivable: { value1: null, externalAccount: null, internalAccount: null }
      })
    },
    statisticRange: {
      type: String,
      default: 'month'
    }
  },
  methods: {
    // 从 salesPreset.vue 中移动过来的方法
    getCardTooltip(type) {
      const rangeText = this.getRangeText();
      const blueStyle = 'color: #409EFF; font-weight: bold;';
      const blackStyle = 'color: #000000;';
      
      let tooltipContent = `<div style="font-size: 12px; line-height: 1.5; padding: 8px;">`;
      tooltipContent += `<div style="${blackStyle} font-weight: 600; margin-bottom: 6px;">${rangeText}</div>`;
      
      switch(type) {
        case 'project':
          tooltipContent = this.getProjectCardTooltip();
          break;
          
        case 'contract':
          tooltipContent += `<div style="margin-bottom: 4px;"><span style="${blackStyle}">未审核金额：</span><span style="${blueStyle}">${this.formatToTenThousand(this.cardData.contract.value1)}</span></div>`;
          tooltipContent += `<div style="margin-bottom: 4px;"><span style="${blackStyle}">累计金额：</span><span style="${blueStyle}">${this.formatToTenThousand(this.cardData.contract.value2)}</span></div>`;
          tooltipContent += `<div><span style="${blackStyle}">未审核数量：</span><span style="${blueStyle}">${this.formatNumber(this.cardData.contract.unReviewCount)}个</span></div>`;
          break;
          
        case 'execute':
          tooltipContent += `<div style="margin-bottom: 4px;"><span style="${blackStyle}">异常执行合同数：</span><span style="${blueStyle}">${this.formatNumber(this.cardData.execute.value1)}个</span></div>`;
          tooltipContent += `<div><span style="${blackStyle}">执行中合同总数：</span><span style="${blueStyle}">${this.formatNumber(this.cardData.execute.value2)}个</span></div>`;
          break;
          
        case 'shipment':
          tooltipContent += `<div style="margin-bottom: 4px;"><span style="${blackStyle}">异常发运合同总数：</span><span style="${blueStyle}">${this.formatNumber(this.cardData.shipment.value1)}个</span></div>`;
          tooltipContent += `<div><span style="${blackStyle}">待发运合同总数：</span><span style="${blueStyle}">${this.formatNumber(this.cardData.shipment.value2)}个</span></div>`;
          break;
          
        case 'afterSales':
          tooltipContent += `<div style="margin-bottom: 4px;"><span style="${blackStyle}">未完成售后数：</span><span style="${blueStyle}">${this.formatNumber(this.cardData.afterSales.value1)}个</span></div>`;
          tooltipContent += `<div><span style="${blackStyle}">售后总数：</span><span style="${blueStyle}">${this.formatNumber(this.cardData.afterSales.value2)}个</span></div>`;
          break;
          
        case 'receivable':
          tooltipContent += `<div style="margin-bottom: 4px;"><span style="${blackStyle}">应收金额（含预收）：</span><span style="${blueStyle}">${this.formatToTenThousand(this.cardData.receivable.value1)}</span></div>`;
          tooltipContent += `<div style="margin-bottom: 4px;"><span style="${blackStyle}">网点外部账款（含预收）：</span><span style="${blueStyle}">${this.formatToTenThousand(this.cardData.receivable.externalAccount)}</span></div>`;
          tooltipContent += `<div><span style="${blackStyle}">自签内部账款（含预收）：</span><span style="${blueStyle}">${this.formatToTenThousand(this.cardData.receivable.internalAccount)}</span></div>`;
          break;
          
        default:
          tooltipContent += `<div style="${blackStyle}">暂无数据</div>`;
      }
      
      tooltipContent += `</div>`;
      return tooltipContent;
    },

    getProjectCardTooltip() {
      const rangeText = this.getRangeText();
      const blueStyle = 'color: #409EFF; font-weight: bold;';
      const blackStyle = 'color: #000000;';
      const tableBorderStyle = 'border: 1px solid #ebeef5;';
      const tableCellStyle = 'border: 1px solid #ebeef5; text-align: center; padding: 4px 8px; font-weight: 400;';
      const tableHeaderStyle = 'border: 1px solid #ebeef5; text-align: center; padding: 4px 8px; font-weight: 600; background: #f5f7fa;';
      
      let tooltipContent = `<div style="font-size: 12px; line-height: 1.5; font-family: 'Microsoft YaHei', sans-serif;">`;
      tooltipContent += `<div style="${blackStyle} font-weight: 600; margin-bottom: 8px;">${rangeText}</div>`;
      tooltipContent += `<div style="${blackStyle} margin-bottom: 12px;">`;
      tooltipContent += `<span style="${blackStyle}">已投标数：</span><span style="${blueStyle}">${this.formatNumber(this.cardData.project.value1)}个</span>`;
      tooltipContent += `<span style="${blackStyle}">； 项目总数：</span><span style="${blueStyle}">${this.formatNumber(this.cardData.project.value2)}个</span>`;
      tooltipContent += `</div>`;
      tooltipContent += `<div style="${tableBorderStyle} display: flex; margin-bottom: 0; ${blackStyle}">`;
      tooltipContent += `<div style="${tableHeaderStyle} flex: 1;">类型</div>`;
      tooltipContent += `<div style="${tableHeaderStyle} flex: 1;">数量(个)</div>`;
      tooltipContent += `<div style="${tableHeaderStyle} flex: 1;">比例(%)</div>`;
      tooltipContent += `<div style="${tableHeaderStyle} flex: 1;">金额(万)</div>`;
      tooltipContent += `<div style="${tableHeaderStyle} flex: 1;">占比(%)</div>`;
      tooltipContent += `</div>`;
      
      const tableData = this.cardData.project.tableData.bidding || [];
      tableData.forEach(item => {
        tooltipContent += `<div style="${tableBorderStyle} display: flex; ${blackStyle}">`;
        tooltipContent += `<div style="${tableCellStyle} flex: 1;">${item.type}</div>`;
        tooltipContent += `<div style="${tableCellStyle} flex: 1;">${this.formatNumber(item.count)}</div>`;
        tooltipContent += `<div style="${tableCellStyle} flex: 1;">${this.formatNumber(item.ratio)}</div>`;
        tooltipContent += `<div style="${tableCellStyle} flex: 1;">${this.formatNumber(item.amount)}</div>`;
        tooltipContent += `<div style="${tableCellStyle} flex: 1;">${this.formatNumber(item.percentage)}</div>`;
        tooltipContent += `</div>`;
      });
      
      tooltipContent += `</div>`;
      return tooltipContent;
    },
    
    getRangeText() {
      switch(this.statisticRange) {
        case 'year': return '本年度';
        case 'month': return '本月度';
        case 'week': return '本周';
        default: return '';
      }
    },
    
    formatCurrency(value) {
      if (typeof value !== 'number') return '0.00';
      return value.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    formatToTenThousand(value) {
      if (value === null || value === undefined) return '0.00';
      
      const numValue = typeof value === 'string' ? 
        parseFloat(value.replace(/[^0-9.-]+/g, '')) : 
        Number(value);
      
      if (isNaN(numValue) || numValue === 0) return '0.00';
      
      const inTenThousand = numValue / 10000;
      return inTenThousand.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + '万';
    },
    
    formatNumber(value) {
      if (value === null || value === undefined) return '0';
      
      const numValue = typeof value === 'string' ? 
        parseFloat(value.replace(/[^0-9.-]+/g, '')) : 
        Number(value);
      
      if (isNaN(numValue)) return '0';
      return numValue.toLocaleString('zh-CN');
    }
  }
};
</script>

<style scoped lang="scss">
.summary-cards-container {
  display: flex;
  flex-wrap: nowrap; /* 防止换行 */
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
  // margin-bottom: 10px;
  margin-bottom: 0px;
  gap: 15px;
  overflow-x: hidden; /* 水平隐藏溢出 */
  overflow-y: hidden; /* 防止垂直滚动 */

  .summary-card {
    flex: 1; /* 使卡片平均分布 */
    min-width: 0; /* 允许缩小，避免溢出 */
    height: 100px;
    display: flex;
    align-items: center;
    padding: 0 10px; /* 调整内边距 */
    background-color: rgba(37, 100, 207, 0.06);
    border-radius: 4px;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
    position: relative; /* 为绝对定位提供参考 */
    
    .card-left {
      width: 44px;          /* 收窄，让数据列有更多空间 */
      height: 96px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 4px 0;
      flex-shrink: 0; /* 防止左侧被压缩 */
      transition: all 0.3s ease; /* 添加过渡效果 */
      justify-content: center;
      .card-icon {
        width: 100%;
        height: 44px;       /* 图标本身也小一档，给数据让位 */
        overflow: hidden;
        position: relative;
        flex-shrink: 0;
        
        .card-image {
          width: 100%;
          height: 100%;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
        
        .composite-icon {
          width: 100%;
          height: 100%;
          position: relative;
          
          .card-image-bg {
            position: absolute;
            width: 87.87%;
            height: 87.87%;
            object-fit: contain;
            left: 6.03%;
            top: 5.97%;
          }

          .card-image-fg {
            position: absolute;
            width: 43.92%;
            height: 31.98%;
            object-fit: contain;
            left: 30.1%;
            top: 35.43%;
          }
        }
      }
      
      .card-title {
        font-size: 13px;        /* 标题也收一档（原来是 16px） */
        font-family: "Microsoft YaHei-Bold";
        font-weight: 700;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%; /* 改为100%适应容器 */
        height: 24px;            /* 跟随字号缩小 */
        color: rgba(0, 0, 0, 1);
      }
    }
    
    .card-right {
      flex: 1; /* 右侧自适应宽度 */
      height: 96px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      letter-spacing: 1px;
      padding-left: 6px; /* 添加左边距，与左侧内容分开 */
      transition: all 0.3s ease; /* 添加过渡效果 */
            /* 添加文本溢出控制 */
      white-space: nowrap;      /* 禁止换行 */
      overflow: hidden;         /* 隐藏溢出内容 */
      text-overflow: ellipsis;  /* 用省略号代替溢出文本 */
      width: 100%;              /* 确保占满父容器宽度 */
      max-width: 100%;          /* 确保不超过父容器宽度 */
      
      .data-item {
        display: flex;
        flex-direction: column;
        
        .data-value {
          font-size: 14px;
          font-family: "Microsoft YaHei-Regular";
          font-weight: 700;
          color: rgba(0, 0, 0, 1);
          line-height: 28px;
          text-align: center;
          transition: all 0.3s ease; /* 添加过渡效果 */
        }
        
        .data-label {
          font-size: 10px;
          font-family: "Arial-Regular";
          font-weight: 700;
          color: rgba(134, 144, 156, 1);
          line-height: 12px;
          text-align: center;
          transition: all 0.3s ease; /* 添加过渡效果 */
                /* 添加文本溢出控制 */
      white-space: nowrap;      /* 禁止换行 */
      overflow: hidden;         /* 隐藏溢出内容 */
      text-overflow: ellipsis;  /* 用省略号代替溢出文本 */
      width: 100%;              /* 确保占满父容器宽度 */
      max-width: 100%;          /* 确保不超过父容器宽度 */
        }
        
        &.empty-item {
          height: 18px;
        }
      }
      
      /* 移动标签样式 - 在小屏幕时显示 */
      .mobile-card-title {
        display: none; /* 默认隐藏，只在移动端显示 */
        font-size: 16px;
        font-family: "Microsoft YaHei-Bold";
        font-weight: 700;
        text-align: center;
        // color: #409EFF; /* 蓝色字体 */
        /* 添加渐变背景色 */
        background: linear-gradient(to right,     
          rgb(29, 194, 213), 
          rgba(37, 100, 207, 0.7), 
          rgb(25, 137, 250));
        -webkit-background-clip: text;  /* 关键属性：将背景裁剪为文字形状 */
        background-clip: text;           /* 标准属性 */
        -webkit-text-fill-color: transparent; /* 使文字本身透明，显示背景渐变 */
        color: transparent;              /* 标准属性 */
        margin-bottom: 6px; /* 与下方数据项的间距 */
        line-height: 1.2;
      }
    }
  }
}


/* 更小屏幕宽度：600px-900px，进一步调整 */
@media (max-width: 1045px) {
    .summary-cards-container {
    /* 容器：跟页面大小调整 = 100% 流体 + flex + 不换行 */
    width: 100% !important;
    display: flex !important;
    flex-wrap: nowrap !important;
    gap: 10px !important;
  }

  /* 6 张卡片：flex 基准 0 + 等比放大，再大的内容也只会撑破这一格而不会推挤别的卡片 */
  .summary-cards-container > .summary-card {
    flex: 1 1 0% !important;
    min-width: 0 !important;
    width: auto !important;
    box-sizing: border-box !important;
  }

  .summary-cards-container .summary-card {
    flex-direction: column; /* 改为垂直布局 */
    justify-content: center; /* 垂直居中 */
    padding: 8px 4px !important; /* 调整内边距 */
    height: 100px !important; /* 稍微降低高度 */

    .card-left {
      display: none !important; /* 隐藏左侧图标+标签 */
    }

    .card-right {
      padding: 0 !important; /* 移除内边距 */
      text-align: center;
      width: 100%; /* 占满整个卡片宽度 */
      justify-content: center; /* 垂直居中内容 */

      /* 显示移动标签 */
      .mobile-card-title {
        display: block; /* 显示移动标签 */
      }

      .data-item {
        margin-top: 0px; /* 减小间距 */

        .data-value {
          font-size: 16px !important;
          line-height: 20px !important; /* 调整行高 */
        }

        .data-label {
          font-size: 10px !important;
          line-height: 12px !important;
        }
      }

      /* 隐藏应收卡片的空行，调整布局 */
      .empty-item {
        display: none !important;
      }
    }
  }
  .summary-cards-container {
    gap: 8px !important;
  }
  
  .summary-cards-container .summary-card {
    padding: 6px 4px !important;
    min-width: 0 !important; /* 允许进一步缩小 */
    height: 90px !important; /* 进一步降低高度 */
    
    .card-right {
      .mobile-card-title {
        font-size: 13px !important; /* 缩小标签字体 */
        margin-bottom: 2px;
      }
      
      .data-item {
        .data-value {
          font-size: 8px !important;
          line-height: 18px !important;
        }
        
        .data-label {
          font-size: 8px !important;
          line-height: 10px !important;
        }
      }
    }
  }
}


</style>

